import * as React from 'react'

const SvgStarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 4.075l1.725 3.487.287.625.625.094 3.85.556-2.737 2.688-.469.456.113.625.656 3.832-3.444-1.807-.606-.256-.581.306-3.444 1.781.625-3.83.113-.626-.463-.481-2.763-2.719 3.85-.556.626-.094.287-.625L10 4.075zm0-2.825L7.156 7.013.8 7.93l4.6 4.488-1.088 6.331L10 15.762l5.688 2.988-1.088-6.331 4.6-4.482-6.356-.925L10 1.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgStarIcon
